module.exports = __webpack_public_path__ + "img/2f_l_tomatsu@2x.fa93dfc9.jpg";